var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 10.1154 0.00195506 10.2304 0.00583387 10.3448H1.38608C1.38158 10.2304 1.37931 10.1155 1.37931 10C1.37931 5.23892 5.23892 1.37931 10 1.37931C14.7611 1.37931 18.6207 5.23892 18.6207 10C18.6207 14.7611 14.7611 18.6207 10 18.6207C9.88451 18.6207 9.76956 18.6184 9.65517 18.6139V19.9942C9.76964 19.998 9.88459 20 10 20ZM10.8333 2.5V9.16667H15.8333V10.8333H10.8333H9.16667V2.5H10.8333ZM4.58333 20C7.11464 20 9.16667 17.948 9.16667 15.4167C9.16667 12.8854 7.11464 10.8333 4.58333 10.8333C2.05203 10.8333 0 12.8854 0 15.4167C0 17.948 2.05203 20 4.58333 20ZM4.58333 19.2361C6.69275 19.2361 8.40278 17.5261 8.40278 15.4167C8.40278 13.3072 6.69275 11.5972 4.58333 11.5972C2.47391 11.5972 0.763889 13.3072 0.763889 15.4167C0.763889 17.5261 2.47391 19.2361 4.58333 19.2361ZM6.28472 17.8472L4.58333 16.1458L2.88194 17.8472L2.15278 17.1181L3.85417 15.4167L2.15278 13.7153L2.88194 12.9861L4.58333 14.6875L6.28472 12.9861L7.01389 13.7153L5.3125 15.4167L7.01389 17.1181L6.28472 17.8472Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteInspection);
export default __webpack_public_path__ + "static/media/DeleteInspection.fd68b0ca43c30f4806e44db285466d0a.svg";
export { ForwardRef as ReactComponent };